import { type ReactNode } from 'react';
import { ModBoss } from '@vp/mod-father';
import { usePageModsContext } from '../contexts/PageModsProvider';
import { modFatherTracker as hostTracker } from '../../apis/trackingApi';
import {
  commonVpDependenciesV1,
  reorderableItemLineItemDesignInfoV1,
  reorderableItemLineItemInfoV1,
  reorderableItemLineItemInfoV2,
  reorderableItemOrderInfoV1,
  reorderablelineItemMerchandisingInfoV1,
} from '../../utils/uxModContracts';
import { useBuyItAgainItemContext } from '../contexts/BuyItAgainItemContext';
import { useSiteData } from '../../hooks/useSiteData';
import { type ReorderableItem } from '../../types/ReorderableItems.types';
/**
 * This component handles injection of mods on the Buy It Again item level.
 * Such mods can either be from site configuration, with a 'item' scope,
 * or be attached to a reorderable lineItem (within its externalUseData.ux).
 *
 * @param {*} children
 */
export const BuyItAgainItemUxModWrapper = ({
  children,
  item,
}: {
  children: ReactNode;
  item: ReorderableItem;
}) => {
  const { selectedPricedQuantity } = useBuyItAgainItemContext();
  const { activeItemLevelPageUxMods: itemUxMods } = usePageModsContext();
  const { vistacartTenant: vistacartTenantName } = useSiteData();

  const attachedItemMods = item?.externalUseData?.ux || [];

  const environmentData = {
    orderInfoV1: reorderableItemOrderInfoV1(item, vistacartTenantName),
    lineItemInfoV1: reorderableItemLineItemInfoV1(item),
    lineItemInfoV2: reorderableItemLineItemInfoV2(item),
    lineItemDesignInfoV1: reorderableItemLineItemDesignInfoV1(item),
    // for Buy It Again this object makes the currently selectedPricedQuantity available
    lineItemMerchandisingInfoV1: reorderablelineItemMerchandisingInfoV1(
      selectedPricedQuantity
    ),
    commonVpDependenciesV1,
  };

  return (
    <ModBoss
      mods={[...(itemUxMods || []), ...(attachedItemMods || [])]}
      environmentData={environmentData}
      contextKey={item?.lineItemId}
      hostTracker={hostTracker}
    >
      {children}
    </ModBoss>
  );
};
